import { useEffect } from "react";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";
import { useTheme } from "@/contexts/PreferencesContext";

export const useIOSStatusBar = () => {
  const { theme } = useTheme();

  useEffect(() => {
    const updateStatusBar = async () => {
      // Only run on iOS
      if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") {
        return;
      }

      try {
        // Set status bar style and background based on theme
        if (theme === "dark") {
          await StatusBar.setStyle({ style: Style.Light }); // White text for dark theme
          await StatusBar.setBackgroundColor({ color: "#262626" }); // Dark background (15% grey)
        } else {
          await StatusBar.setStyle({ style: Style.Dark }); // Dark text for light theme
          await StatusBar.setBackgroundColor({ color: "#FAFAFA" }); // Light background (98% grey)
        }
      } catch (error) {
        console.error("Failed to update status bar:", error);
      }
    };

    updateStatusBar();
  }, [theme]);
};
